/** @format */
import { Injectable } from '@angular/core';
import { StudyPeriod } from 'common-typescript/types';
import { Observable, shareReplay } from 'rxjs';
import { map } from 'rxjs/operators';
import { SelectedValidatablePlanService } from '../service/selected-validatable-plan.service';
import { TimelineStudyYearsService } from './timeline-study-years.service';

@Injectable()
export class TimelineStudyPeriodsService {
    /**
     * Emits study periods that are visible on the timeline (i.e., periods of {@link TimelineStudyYearsService.studyYears$}).
     * Notice that this is not the full list of study periods!
     * If there is no {@link SelectedValidatablePlanService.selectedValidatablePlan$}, an empty array is returned.
     */
    readonly studyPeriods$: Observable<readonly StudyPeriod[]>;

    constructor(timelineStudyYearsService: TimelineStudyYearsService) {
        this.studyPeriods$ = timelineStudyYearsService.studyYears$.pipe(
            map(studyYears => studyYears.flatMap(studyYear => studyYear.studyTerms.flatMap(studyTerm => studyTerm.studyPeriods))),
            shareReplay({ refCount: true, bufferSize: 1 }),
        );
    }
}
